/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/display-name */
import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

// eslint-disable-next-line no-unused-vars
const slideInLeft = {
    visibility: `visible`,
    animationName: `slideInLeft`,
}

export default props => {
    return (
        <div className="storyCard  mt-4 mb-4 ">
            <a>
                <div className="card mb-4 ">
                    <div className="cardImg storyImg articleImg">
                        <Img style={props.style}
                            imgStyle={{ "opacity": 'none', "transition": 'all 300ms ease-in-out' }}
                            fluid={props.src} alt={props.title} title={props.title} />
                    </div>
                    <div className={(props.bgColor ? props.bgColor : " " + "card-body")}>
                        <hr />
                        <h6 >{props.title}</h6>
                        <p className="card-text">{props.description}</p>
                        {props.link &&
                            <Link
                                to={props.link}
                                className="subtitle1 link mt-3 d-inline-block mt-0 pt-0"
                            >
                                Read More
                            </Link>
                        }
                    </div>
                </div>
            </a>
        </div >
    )
}